import { AccountNumber } from "./AccountNumber";
export default AccountNumber;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/AccountNumber/index.js